var _defs, _path, _path2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperatureCold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Cold",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 80,
    viewBox: "0 0 18 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.131,
    stopColor: "#00adee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0072bc"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M18,71.25A8.873,8.873,0,0,1,9,80a8.88,8.88,0,0,1-9-8.75,8.652,8.652,0,0,1,4.2-7.39V4.66A4.728,4.728,0,0,1,9,0a4.73,4.73,0,0,1,4.81,4.66V63.85A8.694,8.694,0,0,1,18,71.25Z",
    fill: "#58595b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M8.81,24.23h.38a3.325,3.325,0,0,1,3.32,3.32V68.48A3.325,3.325,0,0,1,9.19,71.8H8.81a3.325,3.325,0,0,1-3.32-3.32V27.55A3.318,3.318,0,0,1,8.81,24.23Z",
    fill: "url(#linear-gradient)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_346",
    "data-name": "Ellipse 346",
    cx: 7.58,
    cy: 7.37,
    rx: 7.58,
    ry: 7.37,
    transform: "translate(1.42 63.88)",
    fill: "#00adee"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureCold);
export default __webpack_public_path__ + "static/media/temperature_cold.4e051bf62687f00e1b4b0644fda62cfb.svg";
export { ForwardRef as ReactComponent };